import React from "react";

// Import logos
import babcpLogo from "../../assets/images/professional/BABCPLogo.webp";
import bpsLogo from "../../assets/images/professional/BPSLogoOnlinePsychologistsUK.webp";
import hcpcLogo from "../../assets/images/professional/HCPCLogo.webp";

const ProfessionalAccreditations = () => {
  // Professional associations information with website URLs
  const accreditations = [
    {
      id: 1,
      order: 1,
      name: "BPS",
      fullName: "The British Psychological Society",
      description: "The representative body for psychology and psychologists in the UK",
      logo: bpsLogo,
      website: "https://www.bps.org.uk"
    },
    {
      id: 2,
      order: 2,
      name: "BABCP",
      fullName: "British Association for Behavioural & Cognitive Psychotherapies",
      description: "Leading professional body for CBT practitioners in the UK",
      logo: babcpLogo,
      website: "https://www.babcp.com"
    },
    {
      id: 3,
      order: 3,
      name: "HCPC",
      fullName: "Health and Care Professions Council",
      description: "Regulator of health and care professionals in the UK",
      logo: hcpcLogo,
      website: "https://www.hcpc-uk.org"
    }
  ];

  // Function to handle website redirection
  const handleCardClick = (website) => {
    // Tüm ekranlarda aynı sekmede yönlendir
    window.location.href = website;
  };

  return (
    <div className="container mx-auto px-12 py-10">
      {/* Title */}
      <div className="text-center mb-8">
        <p className="max-w-full sm:max-w-[800px] text-primary text-[16px] sm:text-[18px] md:text-[20px] font-poppins italic mx-auto px-4 sm:px-0">
          All our therapists are registered members of at least one professional body, such as BACP, BPC, or HCPC, at MindTherapyCounselling
        </p>
      </div>

      {/* Accreditation Cards */}
      <div className="flex flex-wrap justify-center gap-8 px-2 sm:px-6 md:px-12">
        {[...accreditations]
          .sort((a, b) => a.order - b.order)
          .map((accreditation) => (
          <div 
            key={accreditation.id}
            className="relative w-full max-w-[280px] bg-white border-[2px] border-cards-border rounded-[20px] shadow-lg overflow-hidden hover:shadow-xl hover:scale-105 transition-all duration-300 ease-in-out p-6 cursor-pointer group"
            onClick={() => handleCardClick(accreditation.website)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleCardClick(accreditation.website);
              }
            }}
          >
            {/* Logo Container */}
            <div className="flex justify-center items-center h-[120px] mb-4">
              <img 
                src={accreditation.logo} 
                alt={`${accreditation.name} Logo`}
                className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y3ZjdmNyIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNjY2IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5Mb2dvPC90ZXh0Pjwvc3ZnPg==';
                }}
              />
            </div>

            {/* Content */}
            <div className="text-center">
              <h3 className="text-text text-[18px] font-bold font-poppins mb-2 group-hover:text-primary transition-colors duration-300">
                {accreditation.name}
              </h3>
              <p className="text-text text-[14px] font-poppins mb-2">
                {accreditation.fullName}
              </p>
              <p className="text-gray-600 text-[12px] font-poppins italic mb-3">
                {accreditation.description}
              </p>
              
              {/* Visit Website Indicator */}
              <div className="flex items-center justify-center mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-primary text-[12px] font-poppins font-medium">
                  Visit Website
                </span>
                <svg 
                  className="ml-1 w-4 h-4 text-primary" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                  />
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfessionalAccreditations;
